import crossIcon from "src/assets/cross.svg";
import { useState } from "react";
import { useToast } from "src/hooks/useToast";
import { closeInvoiceEscalation } from "src/services/invoice-api";
import { Button } from "src/components";

interface InvoiceAcceptProps {
    onCloseModal: () => void;
    onSuccess: () => void;
    invoiceData: any;
    action: string;
    company_code: any;
    agentsuggestion_rating?: "UP" | "DOWN" | "";
}

const InvoiceEscalationAction = ({ onCloseModal, onSuccess, invoiceData, action, company_code, agentsuggestion_rating }: InvoiceAcceptProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [remarks, setRemarks] = useState('') //M10-10515
    const { toast } = useToast();

    const handleResolveInvoice = async () => {
        //M10-10515
        if (!remarks.trim()) {
            toast({ description: "Remarks should not empty", variant: "destructive" });
            return;
        }
        //M10-10515
        if (invoiceData?.agentsuggestion_remarks?.trim() && !agentsuggestion_rating) {
            toast({
                description: "Please choose either a thumbs up or thumbs down rating.",
                variant: "destructive"
            });
            return;
        }
        setIsLoading(true);
        const payload = {
            "id": invoiceData?.id,
            "status": action,
            "agentsuggestion_rating": agentsuggestion_rating,
            "responded_reason": remarks //M10-10515
        }
        const result = company_code.some((item: any) => item?.code === 618) ? 618 : 0;
        try {
            await closeInvoiceEscalation(payload, result);
            toast({ description: "Invoice " + action + " successfully", variant: "default" });
            onCloseModal();
            onSuccess();
        } catch (error: any) {
            toast({ description: error?.response?.data?.message, variant: "destructive" });
        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    return (
        <div className="flex flex-col gap-y-2 w-[345px] mx-auto bg-white px-6 py-4 border border-gray-300 shadow-lg rounded-xl">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#1B1A1F]">{action === "rejected" ? "Reject Invoice" : action === "resolved" ? "Accept Invoice" : "On Hold Invoice"}</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            <p className="text-sm mt-2 font-normal text-[#666666] mb-2">Are you sure you want to {action === "rejected" ? "reject" : action === "resolved" ? "accept" : "on hold"} this invoice?</p>
            {/* <label className="text-sm mt-2 font-normal text-[#666666]">Select Status</label> */}
            {/* <Autocomplete onSelectionChange={(value: any) => setStatus(value)} placeholder="Select Status" suggestionList={[{ label: "Closed", value: "closed" }, { label: "Pending", value: "pending" }]} displayKey="label" uniqueKey="value" /> */}
            {/* M10-10515 */}
            <label className="text-sm mt-2 font-normal text-[#666666]">Enter remarks</label>
            <textarea   maxLength={500} placeholder="Enter remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} className="py-2 px-2 border border-gray-300 rounded-md" />
            {/* M10-10515 */}
            <div className="flex justify-end gap-2 mt-4">
                <Button className="w-fit h-9 mt-0 font-normal border border-[#D0D0D0]  bg-[#F1F1F1] shadow-sm" onClick={onCloseModal}>
                    Cancel
                </Button>
                <Button
                    loaderSize="small"
                    isLoading={isLoading}
                    className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
                    onClick={handleResolveInvoice}
                >
                    {action === "rejected" ? "Reject" : action === "resolved" ? "Accept" : "On Hold"}
                </Button>
            </div>

        </div>
    );
};

export default InvoiceEscalationAction;
